'use es6';

import { bender } from 'legacy-hubspot-bender-context'; // import-eslint-disable-line

const {
  staticDomainPrefix
} = bender;
export const getImageUrl = (name, extension = '.svg', isIE11 = false) => `${staticDomainPrefix}/ui-images/static-2.473/optimized/${name}${isIE11 ? '-ie11' : ''}${extension}`;